import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Ray colour (rgba), default warm golden */
  color?: string;
  /** Rotation angle in degrees, default 25 */
  angle?: number;
  /** Drift cycle duration seconds, default 9 */
  dur?: number;
}

/**
 * GodRays — angled repeating-gradient light shafts drifting slowly
 * with a soft blur, blended in screen mode.
 */
const GodRays: React.FC<Props> = ({
  color = "rgba(255,246,200,0.5)",
  angle = 25,
  dur = 9,
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-rays {
        0%   { transform: translateX(-10%) rotate(${angle}deg); opacity: 0.5; }
        50%  { opacity: 0.85; }
        100% { transform: translateX(10%)  rotate(${angle}deg); opacity: 0.5; }
      }
    `}</style>
    <div
      style={{
        position: "absolute",
        top: "-60%",
        left: "-20%",
        width: "160%",
        height: "220%",
        background: `repeating-linear-gradient(90deg, ${color} 0px, ${color} 18px, transparent 18px, transparent 70px)`,
        filter: "blur(6px)",
        animation: `oot-rays ${dur}s ease-in-out infinite`,
        mixBlendMode: "screen",
      }}
    />
  </div>
);

export default GodRays;
